/**
 * @generated SignedSource<<13656e2226503cb0371f4905a214dd23>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileCard_profile$data = {
  readonly age: number | null | undefined;
  readonly closestCity: string | null | undefined;
  readonly distanceInKilometers: number | null | undefined;
  readonly distanceInMiles: number | null | undefined;
  readonly instagram: string | null | undefined;
  readonly isVerified: boolean | null | undefined;
  readonly name: string;
  readonly rowId: any;
  readonly userId: any;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileVerifiedBadge_profile" | "useProfilePhotos_profile">;
  readonly " $fragmentType": "ProfileCard_profile";
};
export type ProfileCard_profile$key = {
  readonly " $data"?: ProfileCard_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileCard_profile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileCard_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "age",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closestCity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "distanceInKilometers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "distanceInMiles",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instagram",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileVerifiedBadge_profile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useProfilePhotos_profile"
    }
  ],
  "type": "Profile",
  "abstractKey": null
};

(node as any).hash = "22c67a70ed70c58117f8d8673afef91e";

export default node;
